import { Component } from '@angular/core';

@Component({
  selector: 'app-sypr-contemplation',
  templateUrl: './sypr-contemplation.component.html',
  styleUrls: ['./sypr-contemplation.component.scss']
})
export class SyprContemplationComponent {

}
